/**
 * Enhancer Custom Window Configurator
 * @author zyz
 */

require('./index.less');

var locale = require('./i18n');
var template = require('./index.html');

var controllerSample = require('./sample/controller.txt');
var styleSample = require('./sample/style.txt');
var viewSample = require('./sample/view.txt');

var variableManager = require('./managers/variable');
var eventManager = require('./managers/event');
var datasourceManager = require('./managers/datasource');

var configurator = {
    constructor: function() {
        var tplHTML = template({
            locale: locale(),
        });
        $('body').html(tplHTML);

        $('#tabs').tabs();
        var that = this;

        // fit for the conflict between tabs and ace editor
        setTimeout(function() {
            that.viewEditor = Enhancer.Editor.createAutocompleteEditor( 
                'window-view-editor',
                {
                    mode: 'html',
                    enableLiveAutocompletion: false
                }
            );
            that.viewEditor.getSession().setValue(viewSample);
        }, 1);
        this.styleEditor = Enhancer.Editor.createAutocompleteEditor( 
            'window-style-editor',
            { 
                mode: 'css',
                enableLiveAutocompletion: false
            }
        );
        this.styleEditor.getSession().setValue(styleSample);

        this.controllerEditor = Enhancer.Editor.createAutocompleteEditor( 
            'window-controller-editor',
            { mode: 'javascript', enableLiveAutocompletion: false}
        );
        this.controllerEditor.getSession().setValue(controllerSample);

        variableManager.init();
        eventManager.init();
        datasourceManager.init();
    },

    setProfile: function(profile) {
        profile = profile || {};
        var that = this;
        if (this.viewEditor) {
            this.viewEditor.getSession().setValue(
                typeof profile.view === 'undefined' ?
                    viewSample : profile.view
            );
        } else {
            setTimeout(function() {
                that.viewEditor.getSession().setValue(
                    typeof profile.view === 'undefined' ?
                        viewSample : profile.view
                );
            }, 5);
        }
        this.styleEditor.getSession().setValue(
            typeof profile.style === 'undefined' ?
                styleSample : profile.style
        );
        this.controllerEditor.getSession().setValue(
            typeof profile.controller === 'undefined' ?
                controllerSample : profile.controller
        );
        datasourceManager.setDatasourceList(profile.datasources);
        variableManager.setSupportedVariableList(profile.variables);
        variableManager.setDependentVariableList(profile.depVariables);
        eventManager.setSupportedEventList(profile.events);
    },

    getProfile: function() {

        return {
            view: this.viewEditor.getSession().getValue(),
            style: this.styleEditor.getSession().getValue(),
            controller: this.controllerEditor.getSession().getValue(),
            datasources: datasourceManager.getDatasourceList(),
            variables: variableManager.getSupportedVariableList(),
            depVariables: variableManager.getDependentVariableList(),
            events: eventManager.getSupportedEventList()
        };
    },
    
    getSupportedEventList: function() {
        console.log(eventManager.getSupportedEventList());
        return eventManager.getSupportedEventList();
    },

    getSupportedVariableList: function() {
        return variableManager.getSupportedVariableList();
    },

    getDependentVariableList: function() {
        return variableManager.getDependentVariableList();
    }

    // getDependentDatasourceList: function() {
    //     return datasourceManager.getDatasourceList();
    // }
};


Enhancer.registerWidgetConfigurator(configurator);


/*****************
 ** WEBPACK FOOTER
 ** ./src/index.js
 ** module id = 0
 ** module chunks = 0
 **/